// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionTermsAndConditions_container__2Idfr","title":"SectionTermsAndConditions_title__rDH24","content":"SectionTermsAndConditions_content__B5yax"};